import React, { useState } from 'react';
import { QrCode, X, Camera, RefreshCw } from 'lucide-react';

interface QrScannerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onScan: (codigoQr: string) => void;
}

export const QrScannerModal: React.FC<QrScannerModalProps> = ({
  isOpen,
  onClose,
  onScan
}) => {
  const [manualCode, setManualCode] = useState('');

  if (!isOpen) return null;

  const handleSubmitManual = (e: React.FormEvent) => {
    e.preventDefault();
    if (manualCode.trim()) {
      onScan(manualCode.trim());
      setManualCode('');
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-brand-dark/90 backdrop-blur-md">
      <div className="card-blueprint rounded-3xl max-w-md w-full p-6 sm:p-8 relative shadow-2xl border-brand-cyan/50">
        <button
          onClick={onClose}
          className="absolute top-6 right-6 p-2 rounded-full bg-brand-surface text-slate-300 hover:text-white"
          aria-label="Cerrar modal"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="flex flex-col items-center text-center">
          <div className="w-14 h-14 rounded-2xl bg-brand-surface border border-brand-cyan/40 flex items-center justify-center text-brand-cyan mb-4 shadow-glow-cyan">
            <Camera className="w-7 h-7" />
          </div>

          <h3 className="text-xl font-extrabold text-white mb-2">
            Escanear Código QR
          </h3>
          <p className="text-xs text-slate-300 mb-6">
            Apuntá la cámara al código QR de la credencial o ingresá el código alfanumérico manualmente.
          </p>

          {/* Visor de Cámara Simulado / Frame del Escáner */}
          <div className="relative w-64 h-64 rounded-2xl bg-black border-2 border-brand-cyan/80 flex flex-col items-center justify-center overflow-hidden mb-6 shadow-inner">
            <div className="absolute inset-0 bg-brand-cyan/5 animate-pulse"></div>
            <div className="w-48 h-48 border border-dashed border-brand-sky rounded-xl flex items-center justify-center relative">
              <span className="w-full h-0.5 bg-brand-cyan/80 absolute top-1/2 -translate-y-1/2 shadow-glow-cyan"></span>
              <QrCode className="w-20 h-20 text-brand-sky/40" />
            </div>
            <span className="absolute bottom-3 text-[10px] text-brand-sky/80 uppercase tracking-widest font-mono">
              Sensor Activo
            </span>
          </div>

          {/* Formulario Manual */}
          <form onSubmit={handleSubmitManual} className="w-full space-y-3">
            <div className="relative">
              <input
                type="text"
                value={manualCode}
                onChange={(e) => setManualCode(e.target.value)}
                placeholder="Ej: QR-CONGRESO-001"
                className="w-full px-4 py-3 rounded-xl bg-brand-dark/80 border border-brand-cyan/40 text-white placeholder-slate-500 text-sm focus:outline-none focus:border-brand-cyan focus:ring-1 focus:ring-brand-cyan uppercase font-mono text-center"
              />
            </div>

            <div className="flex gap-2">
              <button
                type="submit"
                className="flex-1 py-3 rounded-xl bg-brand-cyan hover:bg-brand-sky text-brand-dark font-heading font-extrabold text-sm uppercase transition-all shadow-glow-cyan"
              >
                Procesar Código
              </button>
              <button
                type="button"
                onClick={() => setManualCode(`TEST-${Math.floor(1000 + Math.random() * 9000)}`)}
                className="p-3 rounded-xl bg-brand-surface hover:bg-brand-navy text-brand-sky border border-brand-cyan/30"
                title="Generar código de prueba"
              >
                <RefreshCw className="w-4 h-4" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
